/**
 * 复制文本到剪贴板
 * 支持HTTP环境下使用textarea fallback
 * @param {string} text - 要复制的文本
 * @returns {Promise<boolean>} - 是否复制成功
 */
export const copyToClipboard = (text) => {
  return new Promise((resolve) => {
    // 优先使用 navigator.clipboard
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        resolve(true);
      }).catch(() => {
        // fallback
        fallbackCopy(text) ? resolve(true) : resolve(false);
      });
    } else {
      // fallback for older browsers or HTTP
      resolve(fallbackCopy(text));
    }
  });
};

/**
 * 使用 textarea 的 fallback 方法
 */
const fallbackCopy = (text) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  textarea.style.top = '0';
  textarea.setAttribute('readonly', '');
  document.body.appendChild(textarea);
  textarea.select();
  try {
    document.execCommand('copy');
    return true;
  } catch (err) {
    console.error('Copy failed:', err);
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
};

export default copyToClipboard;
